import React from 'react'
import "../css/Footer.scss"
const Footer = () => {
  return (
    <div className='footer-section'>
      <p>Thanks for visiting to my portfolio website i hope u like the design and animations.This website is currently at developement stage , more features will be available in future.</p> 
      <span>Made With ❤️️ by <h2>Asad Ansari</h2></span>
      <span>Please follow me on social handles for more amazing designs ! </span>
    </div>
  )
}

export default Footer